import React from 'react';
import { GLUtils } from '@capture/gl-core';
import { PatternTypes, PatternColorModes } from '@capture/pattern-core/src/PatternTypes';
import PatternGLPipeline from '@capture/pattern-core/src/PatternGLPipeline'
import Button from '@react/react-spectrum/Button'
import ThumbsUpDown from "../components/ThumbsUpDown"
import DownloadTopPanel from "../components/DownloadTopPanel"
import sqsvg from "../Imgs/sqsvg.svg"
import hexsvg from "../Imgs/hexsvg.svg"
import eighthexsvg from "../Imgs/eighthexsvg.svg"
import sqlatch from "../Imgs/sqlatch.svg"
import diamondsvg from "../Imgs/diamondsvg.svg"
import Header from "../components/headers/Header"
import CaptureAnalytics from '../analytics/CaptureAnalytics';
import Info from '@react/react-spectrum/Icon/Info';
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger';
import Popover from '@react/react-spectrum/Popover';
import { PatternCropRotatePipeline} from '@capture/pattern-core';
import GlobalUtil from '../utils/GlobalUtil';
import DownloadCard from '../components/DownloadCard';
import { success } from '@react/react-spectrum/Toast';
import ModalContainer from '@react/react-spectrum/ModalContainer';
import PatternCropCanvas from '../components/pattern/PatternCropCanvas';
import globalUtil from '../utils/GlobalUtil'
import './PatternTheme.scss';
import getConfigQA from '../config/index';
import LibraryManager from '../components/upload/LibraryManager';
import {connect} from 'react-redux';

class PatternTheme extends React.Component {

    state = {
        patternName:'SixFoldReflectedFilter',
        selectedTabId: 0,
        data: null,
        loaded:false,
        isLoading: false,
        image: null,
        canvas: React.createRef(),
        color: true,
        scaleValue: 1,
        rotateValue: 0,
        current: 0,
        pngUrl:null
    };
    constructor(props) {
        super(props);
        this.canvas = React.createRef();
        this.gl = null;
        this.atStart = true;
        this.frameID = null;
        this.texture = null;
        this.dialog_key = null;
        this._draw = this._draw.bind(this);
        this._loadTexture = this._loadTexture.bind(this);
        this._updateDimensions = this._updateDimensions.bind(this);
        this.patterns = [
            { name: 'SixFoldReflectedFilter', img: hexsvg }, { name: 'FourFoldReflectedFilter', img: sqlatch }, { name: 'EightFoldReflectedFilter', img: diamondsvg }, { name: 'TwelveFoldReflectedFilter', img: eighthexsvg }, { name: 'SquareFilter', img: sqsvg }]
    }
    handlePress = () => {
        GlobalUtil.printLog("--------down-----");
        if (this.frameID) {
            cancelAnimationFrame(this.frameID);
        }
        if (GlobalUtil.drawID) {
            cancelAnimationFrame(GlobalUtil.drawID);
        }
        if (GlobalUtil.drawOutlineID) {
            cancelAnimationFrame(GlobalUtil.drawOutlineID);
        }
        this.frameID = requestAnimationFrame(this._draw);
        GlobalUtil.drawID = requestAnimationFrame(GlobalUtil.trianleToolDraw);
        GlobalUtil.drawOutlineID = requestAnimationFrame(GlobalUtil.trianleToolDrawOutline);
    }
    handleRelease = () => {
        GlobalUtil.printLog("--------up-------");
        cancelAnimationFrame(this.frameID);
        cancelAnimationFrame(GlobalUtil.drawID);
        cancelAnimationFrame(GlobalUtil.drawOutlineID);
        window.sessionStorage.setItem('patternOffsetX',PatternGLPipeline.getOffset()[0]);
        window.sessionStorage.setItem('patternOffsetY',PatternGLPipeline.getOffset()[1]);
        
    }
    loadFromSessionStorage = () => {
        const showDialog = () => {
            if (window.sessionStorage.patternDownloadDialog && window.sessionStorage.patternDownloadDialog==='true') {
                this.handleSave();
            }
        }
        const fromDefault = () => {
            if (window.adobeIMS.isSignedInUser() === undefined || window.adobeIMS.hasJustReturnedFromAuthorize === undefined) {//from landing, url Hit, from IMS fro signed out and url hit for signed in.
                return true;
            }
            return false;
        }
        if (fromDefault()) {
            GlobalUtil.sessionStorageClear();
        }
        if (!fromDefault() &&  window.sessionStorage.patternImage) {
            const blob = GlobalUtil.dataURItoBlob(window.sessionStorage.patternImage);
            const resultFile = new File([blob], 'input-image');
            let imgURL = URL.createObjectURL(resultFile);
            this.setState({image: imgURL}, () => {showDialog()})
        }
        else {
            GlobalUtil.imageURLtoDataURL(this.props.image.image);
            this.setState({image: this.props.image.image});
        }
        if (!fromDefault() &&  window.sessionStorage.patternName) {
            this.setState({ selectedTabId: parseInt(window.sessionStorage.patternIndex),patternName:window.sessionStorage.patternName});
            this.setPatternFilter(window.sessionStorage.patternName);
        }
        else {
            this.setPatternFilter(this.patterns[0].name,true);
        }
        if (!fromDefault() &&  window.sessionStorage.patternScale) {
            this.setState({ scaleValue: parseFloat(window.sessionStorage.patternScale) });
            PatternCropRotatePipeline.setScale(parseFloat(window.sessionStorage.patternScale));
            PatternGLPipeline.setScale(parseFloat(window.sessionStorage.patternScale));
        }
        else {
            this._setScale(0);
        }
        if (!fromDefault() &&  window.sessionStorage.patternRotate) {
            this.setState({ rotateValue: parseInt(window.sessionStorage.patternRotate) });
            PatternCropRotatePipeline.setRotation(parseInt(window.sessionStorage.patternRotate));
            PatternGLPipeline.setRotation(parseInt(window.sessionStorage.patternRotate));
        }
        else {
            this._setRotate(0);
        }
        if (!fromDefault() &&  window.sessionStorage.patternOffsetX) {
            this._setPatternOffset([parseFloat(window.sessionStorage.patternOffsetX),parseFloat(window.sessionStorage.patternOffsetY)]);
        }
        else {
            this._setPatternOffset([0,0]);
        }

    }
    componentDidMount() {
        let element = document.querySelector(".patternButtons");
        getConfigQA();
        window.adobeid.api_parameters.authorize.redirect_uri = window.location.href;
        LibraryManager.getLibraries(0,this.props.saveLibs, this.props.libsFetched);
        if (element) {
            element.addEventListener("mousedown", this.handlePress);
            element.addEventListener("mouseup", this.handleRelease);
            element.addEventListener("touchstart", this.handlePress);
            element.addEventListener("touchend", this.handleRelease);
        }
        element = document.querySelector("html");
        if(element) {
            element.classList.remove("noUrlScroll");
            element.classList.add("noUrlScroll");
        }
        element = document.querySelector("#root");
        if (element) {
            element.classList.add("pattern-quick-actions");
        }
        this.sendActivationAnalytic('render');
        this.displayWindowSize();

        this.setState({width: window.innerWidth, height: window.innerHeight});
        // have to reset the pattern, scale, and rotate 
        window.addEventListener("resize", this.displayWindowSize);
        window.scrollTo(0, 0);
        //(globalUtil.isLoggedInUser()) && this.loadLib();
        window.addEventListener('resize', this.updateDimensions);
        GlobalUtil.drawOutlineID = requestAnimationFrame(GlobalUtil.trianleToolDrawOutline);
        setTimeout(() => {cancelAnimationFrame(GlobalUtil.drawOutlineID)},500);
        this.loadFromSessionStorage();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        let element = document.querySelector(".patternButtons");
        if(element) {
            element.removeEventListener("mousedown", this.handlePress);
            element.removeEventListener("mouseup", this.handleRelease);
            element.removeEventListener("touchstart", this.handlePress);
            element.removeEventListener("touchend", this.handleRelease);
        }
        element = document.querySelector("html");
        if(element) {
            element.classList.remove("noUrlScroll");
        }
        element = document.querySelector("#root");
        if (element) {
            element.classList.remove("pattern-quick-actions");
        }
        if (this.dialog_key) {
            ModalContainer.hide(this.dialog_key);
            window.sessionStorage.setItem('patternDownloadDialog',false);
        }
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    resetTools = () => {
        this.setState({
            rotateValue: 0,
            scaleValue: 1,
        })
        PatternCropRotatePipeline.setRotation(0);
        PatternGLPipeline.setRotation(0);
        PatternGLPipeline.setOffset([0,0]);
        PatternCropRotatePipeline.setOffset([0,0]);
        PatternGLPipeline.setScale(1);
        PatternCropRotatePipeline.setScale(1);
    }

    sendActivationAnalytic(type, subType, eventValue) {
		const captureAnalytics = new CaptureAnalytics(window.ENV);
        captureAnalytics.initAnalytics();
        let eventObj;
		switch (type) {
            case 'render':
                eventObj = {
                    workflow: 'Editor Page',
                    setUIFilter: window.matchMedia("(orientation: portrait)").matches ? 'Portrait' : 'Landscape',
                    type: 'render'
                };
                break;
            case 'download':
                eventObj = {
                    workflow: 'Editor Page',
                    subCategory: 'Download',
                    type: 'click'
                };
                break;
            case 'addNew':
                eventObj = {
                    workflow: 'Editor Page',
                    subCategory: 'Upload Photo',
                    type: 'click',
                    subType: 'start'
                };
                break;  
            case 'editPattern':
                eventObj = {
                    workflow: 'Editor Page',
                    subCategory: 'Edit Pattern',
                    type: 'click',
                    subType,
                    value: eventValue ? 'auto' : null
                };
                break;
            case 'rotate':
                eventObj = {
                    workflow: 'Editor Page',
                    subCategory: 'Rotate',
                    type: 'click',
                    value: eventValue
                };
                break; 
            case 'scale':
                eventObj = {
                    workflow: 'Editor Page',
                    subCategory: 'Scale',
                    type: 'click',
                    value: eventValue
                };
                break;              
                  
        }
        captureAnalytics.genericAnalyticEvent(eventObj);
	}

    displayWindowSize = () => {
        // console.log('width ', window.innerWidth)

    }
    componentDidUpdate(prevprops, prevstate) {
        if (prevstate.image !== this.state.image) {
            this._loadTexture(this.state.image);
        }
        if (prevstate.current !== this.state.current) {
            this.patternButtons()
        }
    }

    _draw() {
        const canvas = this.refs.canvas

        if (this.gl && canvas) {
            const pipeline = PatternGLPipeline;
            pipeline.bind(this.gl);
            pipeline.setViewSize(this.gl, canvas.width, canvas.height);
            pipeline.setSize(this.gl, this.textureWidth, this.textureHeight);
            pipeline.draw(this.gl, this.texture);
            GlobalUtil.printLog("draw of outer canvas");
            this.frameID = requestAnimationFrame(this._draw);
        }

    }

    _loadTexture(imageURI) {
        // take out this _updateDimension so the canvas doesn't stretch super big
        // window.addEventListener('resize', this._updateDimensions);
        const canvas = this.refs.canvas;
        this.gl = canvas.getContext('webgl', { preserveDrawingBuffer: true });
        this.texture = GLUtils.loadTexture(this.gl, imageURI, (_, textureWidth, textureHeight) => {
            this.textureWidth = textureWidth;
            this.textureHeight = textureHeight;
            this._updateDimensions();
            if(this.atStart) {
                this.atStart = false;
                this.frameID = requestAnimationFrame(this._draw);
                setTimeout(() => {cancelAnimationFrame(this.frameID)},500);
            }
            //this.frameID = requestAnimationFrame(this._draw);
        });
        // this.setState({loaded:true})
    }

    _updateDimensions() {
        const canvas = this.refs.canvas
        var displayWidth = canvas.clientWidth;
        var displayHeight = canvas.clientHeight;
        if (canvas.width !== displayWidth || canvas.height !== displayHeight) {
            canvas.width = displayWidth*2;
            canvas.height = displayHeight*2;
        }
    }
    _setPatternColor(type) {
        type ? type = PatternColorModes.GreyScale : type = PatternColorModes.Colors
        PatternGLPipeline.setColorMode(type)
        this.setState(prevState => {
            return {
                ...prevState,
                color: !prevState.color
            }
        });
    }
    setPatternFilter(name,auto) {
        PatternGLPipeline.setPatternType(PatternTypes[name]);
        this.sendActivationAnalytic('editPattern',name,auto);
        PatternCropRotatePipeline.setPatternType(PatternTypes[name]);
    }
    deleteClassNameActive = () => {

    }
    _setScale = (e) => {
        if (!e) {
            PatternCropRotatePipeline.setScale(this.state.scaleValue);
            PatternGLPipeline.setScale(this.state.scaleValue);
            return;
        }
        let value = e.target.value
        this.setState({ scaleValue: value })
        PatternGLPipeline.setScale(value);
        PatternCropRotatePipeline.setScale(value);
        clearTimeout(this.inDebounce);
        this.inDebounce = setTimeout(()=>this.sendActivationAnalytic('scale',null,value),100);
        window.sessionStorage.setItem('patternScale',value);
    }
    _setRotate = (e) => {
        if (!e) {
            PatternCropRotatePipeline.setRotation(this.state.rotateValue);
            PatternGLPipeline.setRotation(this.state.rotateValue);
            return;
        }
        let value = e.target.value
        this.setState({ rotateValue: value })
        PatternGLPipeline.setRotation(value);
        PatternCropRotatePipeline.setRotation(value);
        clearTimeout(this.inDebounce);
        this.inDebounce = setTimeout(()=>this.sendActivationAnalytic('rotate',null,value),100);
        window.sessionStorage.setItem('patternRotate',value);
    }

    _setPatternOffset(offsetValue) {
        PatternGLPipeline.setOffset(offsetValue);
        PatternCropRotatePipeline.setOffset(offsetValue);
    }

    patternButtons = () => {
        const { selectedTabId,patternName } = this.state
        return this.patterns.map((pattern, index) => {
            let active = selectedTabId === index
            return (<div className={active ? 'patternButtonSq active' : 'patternButtonSq'}
                onMouseDown={() => {
                    this.setState({ selectedTabId: index,patternName:pattern.name})
                    this.setPatternFilter(pattern.name);
                    window.sessionStorage.setItem('patternName',pattern.name);
                    window.sessionStorage.setItem('patternIndex',index);
                }}
                onTouchStart={() => {
                    this.setState({ selectedTabId: index,patternName:pattern.name})
                    this.setPatternFilter(pattern.name);
                    window.sessionStorage.setItem('patternName',pattern.name);
                    window.sessionStorage.setItem('patternIndex',index);
                }}>
                <img src={pattern.img} />
            </div>)
        }
        )
    }
    patternValues() {
        return this.patterns.map((pattern) => (
            { label: pattern, value: pattern }))
    }

    colorToggleButton() {
        const { color } = this.state
        const colorType = color ? "GreyScale" : "Colors"
        return (
            <Button
                id={colorType}
                onClick={() => {
                    this._setPatternColor(color)
                }}>
                {colorType}
            </Button>)
    }
    downloadCanvas = (canvas) => {
        // download whatever is on the canvas to png first. 
        // then svg 
        console.log('downloading canvas')
        // returns blank .. 

        var url = canvas.toDataURL("image/jpeg");
        console.log(url)
        var link = document.createElement('a');
        link.download = 'capture-pattern.jpg';
        link.href = canvas.toDataURL();
        link.click();
        this.setState({
            link: link.href
        })
    }
    handleSave = () => {
        const key = ModalContainer.show(<DownloadCard 
            image={this.state.image}
            patternName={this.state.patternName} 
            canvasRef={this.refs.canvasDownload}
            onClose={() => {
                ModalContainer.hide(key);
                this.dialog_key = null;
                window.sessionStorage.setItem('patternDownloadDialog',false);
            }} />);
        this.dialog_key = key;
        window.sessionStorage.setItem('patternDownloadDialog',true);
        this.sendActivationAnalytic('download');
    }
    handleUpload = (e) => {
        let img = {};
        if (e.target.files && e.target.files[0]) {
            img = e.target.files[0];
            let src = URL.createObjectURL(img);
            this.setState({
                image: src,
                loaded: true
            });
        }
        this.frameID = requestAnimationFrame(this._draw);
        setTimeout(() => {cancelAnimationFrame(this.frameID)},500);
        GlobalUtil.drawID = requestAnimationFrame(GlobalUtil.trianleToolDraw);
        setTimeout(() => {cancelAnimationFrame(GlobalUtil.drawID)},500);
        GlobalUtil.drawOutlineID = requestAnimationFrame(GlobalUtil.trianleToolDrawOutline);
        setTimeout(() => {cancelAnimationFrame(GlobalUtil.drawOutlineID)},500);
        this.resetTools();
        const reader = new FileReader();
        reader.onloadend = () => {
            window.sessionStorage.setItem('patternImage',reader.result)
        }
        reader.readAsDataURL(img);
    }
    render() {
        const { scaleValue, rotateValue, current,loaded } = this.state

        return (
            <>
            <div class="patternTheme">
                 <div className="canvaswrapper">
                    <div className="topButtons">
                        <div className="pageTitle">
                            <h1>Create a pattern</h1>
                            <h5 className="terms">By downloading this pattern, you agree to the <a href="https://www.adobe.com/privacy/policy.html" target="_blank">Privacy Policy </a>and <a href="https://www.adobe.com/go/terms" target="_blank">Terms of Use.</a></h5>
                        </div>
                        <div className="downloadButtons">
                            <Button variant="cta" onClick={this.handleSave}> Download </Button>
                            <input type="file" name="imgUpload" ref="file" className="inputfile" onChange={this.handleUpload}
                                accept=".png,.jpg"
                            />
                            <Button onClick={() => {this.sendActivationAnalytic('addNew');this.refs.file.click();}}>Add new photo</Button>
                        </div>
                    </div>
                    <canvas className="canvasPattern" ref="canvas"></canvas>
                    <div className="canvasButtons">
                        <Button variant="cta" onClick={this.handleSave}> Download </Button>
                        <Button onClick={() => {this.sendActivationAnalytic('addNew');this.refs.file.click();}}>Add new photo</Button>
                    </div>
                </div>
                 <canvas className="canvasPattern" style ={{display:'none', height:300,width:1000,backgroundColor:'grey'}} ref="canvasDownload"></canvas>
                    <div class="patternButtons">
                        <div className="pageTitle">
                            <h1>Create a pattern</h1>
                            <h5 className="terms">By downloading this pattern, you agree to the <a href="https://www.adobe.com/privacy/policy.html" target="_blank">Privacy Policy </a>and <a href="https://www.adobe.com/go/terms" target="_blank">Terms of Use.</a></h5>
                        </div>
                        <div>
                            <p>Pattern</p>
                            <div class="buttonPatterns">
                                {this.patternButtons()}
                            </div>
                        </div>

                        <div className="rotator">
                            <div className="rotateP">
                                <p style={{ float: "left" }}>Rotate</p><p style={{ float: "right" }}>{rotateValue}<sup>o</sup></p>
                            </div>
                            <div>
                                <input type="range" min="-180" max="180" value={this.state.rotateValue} onChange={this._setRotate} />
                            </div>
                        </div>

                        <div className="numInput">
                            <div>
                                <p style={{ float: "left" }}>Scale</p><p className="scaleValue" style={{ float: "right" }}>{scaleValue}</p>
                            </div>
                            <div>
                                <input className="scaleRangeSelector" defaultValue="0" type="range" min="0.1" max="10" step="0.1" value={this.state.scaleValue} onChange={this._setScale} />
                            </div>
                        </div>
                        
                        <PatternCropCanvas imageURI={this.state.image}></PatternCropCanvas>
                    </div>
            </div>
            <ThumbsUpDown title = {this.props.image.title}/>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveLibs: (libs) => {dispatch({
            type: 'NEWLIBS',
            payload: libs
        })},
        libsFetched: () => {dispatch({
            type: 'LIBSFETCHED'
        })}
    }
}

export default connect(null,mapDispatchToProps)(PatternTheme)
